import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * Prepare the storage for all the authentication
 */
export const authStorageFactory = (): OAuthStorage => localStorage;
